export default "__VITE_ASSET__BO4z3hOb__"